import React, { useEffect, useState } from "react";
import WebEditorRender from "../../../components/WebEditor";
import AiContentSlot from "../../../components/AiContentSlot";
import ApiService from "../../../services/ApiService";

const styles = `
.t26-custom-content {
  max-width: var(--container);
  margin-inline: auto;
  padding: clamp(24px, 4vw, 48px) clamp(16px, 4vw, 32px);
}
`;

/**
 * Section CUSTOM_CONTENT : charge un contenu éditeur (WebEditorRender)
 * ou un bloc AI Content selon `contentType`.
 *
 * Stockage : la section dans `home.sections` peut avoir des props :
 *   { editorPageId: "uuid" }   ← contenu éditeur
 *   { aiContentBlockId: "uuid", contentType: "AI" } ← bloc AI
 */
export default function CustomContent({ context, editorPageId, aiContentBlockId, contentType }) {
    const [data, setData] = useState(null);
    const isAi = contentType === "AI";

    useEffect(() => {
        if (isAi || !editorPageId) return;
        let cancelled = false;
        (async () => {
            try {
                const res = await ApiService.get("/sections/id/" + editorPageId);
                if (!cancelled && res) setData(res.data);
            } catch (err) {
                // silencieux
            }
        })();
        return () => { cancelled = true; };
    }, [editorPageId, isAi]);

    let lang = context.lang?.value || null;
    const languages = context.org?.languages || [];
    if (languages.length > 0 && !lang) lang = context.org.language;

    if (isAi) {
        if (!aiContentBlockId) return null;
        return (
            <>
                <style dangerouslySetInnerHTML={{ __html: styles }} />
                <div className="t26-custom-content">
                    <AiContentSlot blockId={aiContentBlockId} lang={lang} />
                </div>
            </>
        );
    }

    if (!data) return null;

    return (
        <>
            <style dangerouslySetInnerHTML={{ __html: styles }} />
            <div className="t26-custom-content">
                <WebEditorRender page={data} lang={lang} />
            </div>
        </>
    );
}
